<template>
    <div>

        <v-row>
            <v-col class="text-center">
            <span  style="font-size:20px;font-weight:bold;">
                <span class="service">Ecco il tuo appuntamento!</span>
                <br>Mancano solo poche informazioni ...</span>
            </v-col>
        </v-row>

        <steps v-bind:currentStep="step"/>

        <v-row>
            <v-col>
            <p class="text-center">3. Inserisci il tuo <b>nome</b> e il tuo <b>cellulare</b></p>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
               <v-card style="background-color:rgb(64, 211, 230)">
                <v-card-title>Appuntamento</v-card-title>
                <v-card-text>
                    <div>
                        <strong>SERVIZIO:</strong> {{service.name}}
                    </div>
                    <div style="text-transform:capitalize">
                        <strong>DATA:</strong> {{date | moment("dddd D MMMM ")}}
                    </div>
                    <div>
                        <strong>ORARIO:</strong> {{hour}}
                    </div>
                </v-card-text>
            </v-card>
          
            </v-col>
        </v-row>

        <v-row dense>
            <v-col>
                <v-card dark>
                    <v-card-title>Inserisci i tuoi dati</v-card-title>
                    <v-card-text>

                        <v-form v-model="isValid">
                            <v-text-field
                                v-model="name"
                                :rules="nameRules"
                                label="Nome"
                                required
                            ></v-text-field>

                            <v-text-field
                                v-model="phone"
                                :rules="phoneRules"
                                label="Cellulare"
                                type="number"
                                required
                            ></v-text-field>

                            <v-checkbox
                                v-model="terms"
                                :rules="termsRules"
                                label="Accetta termini e condizioni del servizio"
                                required
                            ></v-checkbox>

                            <p><a style="color:#FFFFFF" href="/privacy">Visualizza termini e condizioni del servizio e gestione della privacy</a></p>


                        </v-form>

                    </v-card-text>
                </v-card>
                <v-btn block text outlined  :disabled="!isValid" raised ripple color="#FFFFFF" style="margin-top:10px;background-color:rgb(255, 81, 126)" @click="create()">Conferma</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import steps from "../components/steps"
import { store, mutations } from "../store";
import axios from "axios"


export default {
  name: 'Confirm',

  components: {
      steps
  },
  data: () => ({
    step:3,
    service: store.service, 
    date: store.date,
    hour: store.hour,
    name:"",
    phone:"",
    terms:false,
    completed: store.completed,
    isValid:true,
    nameRules: [
        v => !!v || 'Il nome è obbligatorio',
        v => v.length >= 4 || 'Il nome deve essere almeno di 4 caratteri'
    ],
    phoneRules: [
        v => !!v || 'Il numero di cellulare è obbligatorio',
        v => /^((00|\+)39[\\. ]??)??3\d{2}[\\. ]??\d{6,7}$/.test(v)  || 'Il numero di cellulare non è valido'
    ],
    termsRules: [
        v => !!v || 'Devi accettare i termini e condizioni del servizio'
    ],
  }),
  mounted(){
      if(!this.service || !this.date || !this.hour || this.completed){
          this.$router.push("/");
      }
  },
  computed:{
      isDisabled(){
          if(!this.name || !this.phone){
              return true
          } else {
              return false
          }
      }
  },
  methods:{
    create: function(){
      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/add`,{
          'name':this.name,
          'phone':this.phone,
          'date':`${this.date} ${this.hour}`,
          'item_id':this.service.id
      }).then(() => {
            mutations.setCompleted(true)
            mutations.setName(this.name)
            mutations.setPhone(this.phone)
            this.$router.push("/completed")
          }
        ).catch(() =>{
            this.$router.push("/error");  
      })
    }
  }
};
</script>

<style scoped>
.service{
  color:rgb(64, 211, 230);
}
</style>